/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Duration_LabelInputs */

const en_transcript_export_duration_label = /** @type {(inputs: Transcript_Export_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duration`)
};

const fr_transcript_export_duration_label = /** @type {(inputs: Transcript_Export_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duree`)
};

const de_transcript_export_duration_label = /** @type {(inputs: Transcript_Export_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dauer`)
};

const it_transcript_export_duration_label = /** @type {(inputs: Transcript_Export_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata`)
};

const ru_transcript_export_duration_label = /** @type {(inputs: Transcript_Export_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжительность`)
};

const es_transcript_export_duration_label = /** @type {(inputs: Transcript_Export_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración`)
};

const zh_cn2_transcript_export_duration_label = /** @type {(inputs: Transcript_Export_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期间`)
};

const ja_transcript_export_duration_label = /** @type {(inputs: Transcript_Export_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`間隔`)
};

const hi_transcript_export_duration_label = /** @type {(inputs: Transcript_Export_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अवधि`)
};

const pt_pt2_transcript_export_duration_label = /** @type {(inputs: Transcript_Export_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração`)
};

/**
* | output |
* | --- |
* | "Duration" |
*
* @param {Transcript_Export_Duration_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_duration_label = /** @type {((inputs?: Transcript_Export_Duration_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Duration_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_duration_label(inputs)
	if (locale === "de") return de_transcript_export_duration_label(inputs)
	if (locale === "it") return it_transcript_export_duration_label(inputs)
	if (locale === "ru") return ru_transcript_export_duration_label(inputs)
	if (locale === "es") return es_transcript_export_duration_label(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_duration_label(inputs)
	if (locale === "ja") return ja_transcript_export_duration_label(inputs)
	if (locale === "hi") return hi_transcript_export_duration_label(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_duration_label(inputs)
	return en_transcript_export_duration_label(inputs)
});